import { useEffect } from "react";

const isValidUrl = (domain:string) => {
    let url;
    try {
      url = new URL(domain);
    } catch (_) {
      return false;  
    }
    return url.protocol === "http:" || url.protocol === "https:";
}

export const FormImageList = ({_key,index,name,value,input,change,url}:any) => {
    useEffect(() => {
        return () => {
            const divam = document.getElementById(`fileInput_${_key}`)
            if (divam) {
                const inputam = divam.getElementsByTagName('input')[0] as HTMLInputElement
                inputam.addEventListener("build", (e) => {
                    change(e)
                });
            }
        }
      }, [_key,change])

    const addId = (key:string) => {
        const div = document.getElementById(`fileInput_${key}`)
        if (div) {
            const input = div.getElementsByTagName('input')[0] as HTMLInputElement
            const img = div.getElementsByTagName('img')[0] as HTMLElement
            input.setAttribute('id',"firedInput")
            img.setAttribute('id','firedImage')
        }
    }

    return(
        <div className="input-group mb-3" id={`fileInput_${_key}`}>
            <div className="h-100 mb-4 mx-auto" onClick={() => addId(_key)} data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                <img src={`${isValidUrl(value) ? value : url+value}`} alt="تصویری انتخاب نشده." className="img-fluid rounded"></img>
                <div className="card-img-overlay text-light border-top">
                    <h3 className="position-absolute bottom-0 start-50 translate-middle-x badge text-bg-primary border" role="button">
                        <i className="zmdi zmdi-edit me-2"></i> 
                        تغییر /
                        <i className="zmdi zmdi-upload ms-2 me-2"></i> 
                         اضافه  تصویر
                    </h3>
                </div>
            </div>
            <input type="hidden" className="form-control" name={`${input}:${index}`} defaultValue={value}/>
        </div>
    )
}